/**
 * AiARAiPageView
 *
 * Page component for AiARAiPageView
 * Path: /ar/ai
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AiARAiPageView as __AiARAiPageView } from '@/components/traits/AiARAiPageView';
import { AiARAiAnalyticsView as __AiARAiAnalyticsView } from '@/components/traits/AiARAiAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface AiARAiPageViewProps {
  // Add any page-level props here
}

export function AiARAiPageView(_props: AiARAiPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-ai:meta.title"],"description":["i18n/t","std-almadar-ai:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/ai"},{"locale":"ar","path":"/ar/ai"},{"locale":"sl","path":"/sl/ai"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AiARAiPageView config={{ initPayload: __navState }} />
          <__AiARAiAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AiARAiPageView;
